import { IMenuItem } from '../../models/menu.model';
import type { PublicPortalPersona, PublicPortalSection } from '../../authentication/authentication.service';

export const candidateMenu: IMenuItem[] = [
  {
    path: `home`,
    label: `Home`,
    id: 'MID_CANDIDATE_HOME',
    icon: 'fa fa-home',
  },
  {
    path: `courses`,
    label: `Courses`,
    id: 'MID_CANDIDATE_COURSES',
    icon: 'fa fa-book-reader',
  },
  {
    path: `exam`,
    label: `Examination`,
    id: 'MID_CANDIDATE_EXAM',
    icon: 'fa fa-book',
    children: [
      // { path: `find-certificate`, label: `Find Certificate` },
      {
        path: `take`,
        label: `Take Examinations`,
        id: 'MID_CANDIDATE_TAKE_EXAM',
      },
      { path: `previous`, label: `Examination History`, id: 'MID_CANDIDATE_EXAM_HISTORY' },
      // { path: `take-exam`, label: `Take Exam` },
    ],
  },
  {
    path: `applications/all-applications/create`,
    label: `Other Applications`,
    id: 'MID_CANDIDATE_OTHER_APPLICATIONS',
    icon: 'fa fa-file-alt',
  },
];

export const applicantMenu: IMenuItem[] = [
  {
    path: `home`,
    label: `Home`,
    id: 'MID_APPLICANT_HOME',
    icon: 'fa fa-home',
  },
];

export const publicPortalMenu = (
  persona: PublicPortalPersona,
  section?: PublicPortalSection | null,
): IMenuItem[] => {
  if (persona === 'candidate') return [];
  if (persona === 'applicant') return [];
  if (section === 'agent') return candidateMenu;
  if (section === 'applications') return applicantMenu;
  return [];
};
